import { Box, ButtonBase, Container, IconButton, Paper, Snackbar, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { walletStepEnum } from "libs/constans";
import { Fragment } from "react";
import { changePopupStep, popupSelector } from "./popupSlice";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import QRCode from 'qrcode.react';
import React from "react";

const btn_styles2 = {
    width: '100%',
    background: `linear-gradient(90deg, #BF26E6 -5.41%, #3C14DA 100%)`,
    boxShadow: `0px 4px 15px rgba(0, 0, 0, 0.5)`,
    borderRadius: '24px',
    padding: '14px 24px',
    display: 'flex',
    justifyContent: 'center',
    alignTtems: 'center',
} as const;

export default function ReceiveToken() {

    const { wallet, step, token } = useAppSelector(popupSelector);
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        if (tokenAddress) {
            navigator.clipboard.writeText(tokenAddress);
            setOpen(true);
        }
    }

    const handleClose = (
        event: React.SyntheticEvent | React.MouseEvent,
        reason?: string,
    ) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    if (!token) {
        return <></>
    }
    const tokenAddress = wallet?.address ? wallet?.address : null;
    return (
        <Fragment>
            {step === walletStepEnum.RECEIVE_TOKEN &&
                <>
                    <WalletNav title="Receive Token" />
                    <Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Paper sx={{ width: 200, height: 200, backgroundColor: 'white', p: '5px' }}>
                                {tokenAddress ?
                                    <QRCode
                                        value={tokenAddress}
                                        size={190}
                                    />
                                    :
                                    <Typography>{` `}</Typography>
                                }
                            </Paper>
                        </Box>
                        <Box sx={{ textAlign: 'center', m: 3, wordBreak: 'break-all' }}>
                            <Typography sx={{ fontSize: '15px', color: '#B1BBD2' }}>{tokenAddress}</Typography>
                        </Box>

                        <Box sx={{ textAlign: 'center', m: 3 }}>
                            <Typography sx={{ fontSize: '14px' }}>
                                {`Send only Smart Chain (BNB) to this address. Sending any other coins may result in permanent loss.`}
                            </Typography>
                        </Box>
                        <Box sx={{ p: 3, position: 'absolute', left: '0px', bottom: '20px', width: '100%' }}>
                            <Container fixed maxWidth='sm'>
                                <Box sx={{ mx: 3 }}>
                                    <ButtonBase sx={btn_styles2} onClick={handleClick}>COPY ADDRESS</ButtonBase>
                                </Box>
                            </Container>
                        </Box>
                        <Snackbar
                            open={open}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            autoHideDuration={3000}
                            onClose={handleClose}
                            message="Copied"
                        />
                    </Box>
                </>
            }
        </Fragment>
    );
}

export function WalletNav({ title }: { title: string }) {

    const dispatch = useAppDispatch();
    const { prevStep } = useAppSelector(popupSelector);
    const handleBack = () => {
        dispatch(changePopupStep(prevStep))
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
            <IconButton onClick={handleBack}>
                <KeyboardBackspaceIcon />
            </IconButton>
            <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{title}</Typography>
            <IconButton>

            </IconButton>
        </Box>
    );
}